import { SvgBase } from "../svg.base";

export const Cell = () => (
  <SvgBase
    width="30"
    height="30"
    viewBox="0 0 40 40"
  >
     <g fill="none" fillRule="evenodd">
        <g fill="#FFF" fillRule="nonzero">
            <g>
                <g>
                    <path d="M28.333 3.333c1.841 0 3.334 1.493 3.334 3.334V35c0 1.84-1.493 3.333-3.334 3.333H11.667c-1.841 0-3.334-1.492-3.334-3.333V6.667c0-1.841 1.493-3.334 3.334-3.334h16.666zm0 2.5H11.667c-.41 0-.75.295-.82.684l-.014.15V35c0 .41.295.75.684.82l.15.013h16.666c.41 0 .75-.294.82-.683l.014-.15V6.667c0-.41-.295-.75-.684-.82l-.15-.014zM20 30c.92 0 1.667.746 1.667 1.667 0 .92-.747 1.666-1.667 1.666s-1.667-.746-1.667-1.666c0-.92.747-1.667 1.667-1.667z" transform="translate(-817 -102) translate(645 102) translate(172)"/>
                </g>
            </g>
        </g>
    </g>
  </SvgBase>
);